import React from "react";
import { useUnifiedService } from "../../../utilities/contexts/UnifiedServiceContext";
import AutoTaggingResults from "./AutoTaggingResults";
import BodyMeasurementResults from "./BodyMeasurementResults";
import VisualSearchResults from "./VisualSearchResults";
import GarmentMeasurementResults from "./GarmentMeasurementResults";
import UnifiedResultsNavigation from "../UnifiedResultsNavigation";

const UnifiedResultsStep: React.FC = () => {
  const { serviceConfig, bodyMeasurement, autoTagging, visualSearch, garmentMeasurement } = useUnifiedService();

  const renderResults = () => {
    switch (serviceConfig.serviceId) {
      case "body-measurement":
        return renderBodyMeasurementResults();
      case "auto-tagging":
        return renderAutoTaggingResults();
      case "visual-search":
        return renderVisualSearchResults();
      case "garment-measurement":
        return renderGarmentMeasurementResults();
      default:
        return (
          <div className="text-center">
            <h2 className="text-xl font-medium text-gray-600">Service not implemented yet</h2>
          </div>
        );
    }
  };

  const renderBodyMeasurementResults = () => {
    const { measurementData, frontImage } = bodyMeasurement;

    if (!measurementData) {
      return (
        <div className="text-center">
          <h2 className="text-xl font-medium text-gray-600">No measurement data available</h2>
        </div>
      );
    }

    return <BodyMeasurementResults result={measurementData} uploadedImage={frontImage.preview || undefined} />;
  };

  const renderAutoTaggingResults = () => {
    const { result, image } = autoTagging;

    if (!result) {
      return (
        <div className="text-center">
          <h2 className="text-xl font-medium text-gray-600">No auto-tagging results available</h2>
        </div>
      );
    }

    return <AutoTaggingResults result={result} uploadedImage={image.preview || undefined} />;
  };

  const renderVisualSearchResults = () => {
    const { recognizedClothing, image } = visualSearch;

    if (!recognizedClothing) {
      return (
        <div className="text-center">
          <h2 className="text-xl font-medium text-gray-600">No visual clothes search results available</h2>
        </div>
      );
    }

    return <VisualSearchResults result={recognizedClothing} uploadedImage={image.preview || undefined} />;
  };

  const renderGarmentMeasurementResults = () => {
    const { result } = garmentMeasurement;

    if (!result) {
      return (
        <div className="text-center">
          <h2 className="text-xl font-medium text-gray-600">No garment measurement results available</h2>
        </div>
      );
    }

    return <GarmentMeasurementResults />;
  };

  return (
    <div className="flex flex-col items-center w-full gap-4">
      {renderResults()}
      <UnifiedResultsNavigation />
    </div>
  );
};

export default UnifiedResultsStep;
